import { call, put, takeEvery } from "redux-saga/effects";

import {
  MANUAL_PURCHASE_SUBJECT,
  ManualPurchaseSubjectAction,
} from "./actionTypes";

import { manualPurchaseSubject } from "../../helpers/backend_helper";
import {
  manualPurchaseSubjectError,
  manualPurchaseSubjectSuccess,
} from "./actions";

function* manualPurchaseSubjectSaga({
  payload: { request, history },
}: ManualPurchaseSubjectAction) {
  try {
    yield call(manualPurchaseSubject, request);
    yield put(manualPurchaseSubjectSuccess());
  } catch (error) {
    yield put(manualPurchaseSubjectError(error));
  }
}

function* PurchaseSaga() {
  yield takeEvery(MANUAL_PURCHASE_SUBJECT, manualPurchaseSubjectSaga);
}

export default PurchaseSaga;
